import { inject, Injectable, signal } from '@angular/core';
import { MegaMenuItem } from 'primeng/api';
import { Store } from '@ngrx/store';
import { selectMenuItems } from '../store/webshop/webshop.selectors';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  menuOpen = signal(false);
  private store = inject(Store);
  menuItems = toSignal(this.store.select(selectMenuItems), {initialValue: []});

  getMenuItems(): MegaMenuItem[] {
    return this.menuItems();
  }
}
